import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const title = css`
  font-weight: 700;
`;

export const addComment = css`
  font-size: 15px;
  font-weight: 600;
`;

export const noComments = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
  font-weight: 600;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
`;

export const comments = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const comment = css`
  &:before {
    content: ' ';
    width: 100%;
    margin-bottom: 2rem;
    height: 1px;
    display: block;
    background-color: ${theme.colors.peoople['gris-claro']};
  }
`;

export const moreComments = css`
  align-self: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    align-self: flex-end;
  }
`;

export const firstCommentBtn = css`
  font-weight: 500;
`;
